module.exports = __webpack_public_path__ + "img/SportsWarning.f50f60f8.svg";